if (!customElements.get('video-carousel')) {
  class VideoCarousel extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.vc-slider');
      if (!this.slider) return;

      const slidesDesktop = parseInt(this.slider.dataset.slidesDesktop) || 3;
      const slidesMobile = parseFloat(this.slider.dataset.slidesMobile) || 1.3;
      const gap = parseInt(this.slider.dataset.gap) || 20;
      const loop = this.slider.dataset.loop === 'true';

      this.carousel = new FoxTheme.Carousel(this.slider, {
        slidesPerView: slidesMobile,
        spaceBetween: gap / 2,
        centeredSlides: true,
        loop: loop,
        grabCursor: true,
        navigation: {
          nextEl: this.querySelector('.vc-next'),
          prevEl: this.querySelector('.vc-prev'),
        },
        pagination: {
          el: this.querySelector('.vc-pagination'),
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: slidesDesktop,
            spaceBetween: gap,
          },
        },
      });
      this.carousel.init();

      this.carousel.slider.on('slideChange', () => {
        this.pauseNonActiveMedia();
      });
    }

    pauseNonActiveMedia() {
      const slides = this.querySelectorAll('.vc-slide');
      slides.forEach((slide) => {
        if (slide.classList.contains('swiper-slide-active')) return;

        const video = slide.querySelector('video');
        if (video && !video.paused) {
          video.pause();
        }

        const iframe = slide.querySelector('iframe');
        if (iframe) {
          const src = iframe.src;
          if (src.includes('youtube.com')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (src.includes('vimeo.com')) {
            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }
      });
    }
  }
  customElements.define('video-carousel', VideoCarousel);
}
